import { UrlConstants } from "../utils/CommonUtils/constants";

const createAssessmentApi = (url, requestBody) => {
  const options = {
    method: "POST",
    body: JSON.stringify(requestBody),
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PATCH",
      Authorization: `Bearer ${UrlConstants.TOKEN}`,
    },
  };

  return fetch(url, options).then((res) => {
    if (!res.ok) {
      return {
        status: "ERROR",
        data: "Error occurred...",
      };
    }
    return res.json();
  });
};

export default createAssessmentApi;
